import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';

function Drivers({ user }) {
  const navigate = useNavigate();
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDrivers();
  }, []);

  const fetchDrivers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/drivers', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDrivers(response.data);
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors du chargement des chauffeurs');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="container"><div className="loading">Chargement...</div></div>;
  }

  return (
    <div className="container">
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
          <h2>Chauffeurs</h2>
          {(user.role === 'admin' || user.role === 'manager') && (
            <button
              onClick={() => navigate('/drivers/new')}
              style={{
                padding: '0.8rem 1.5rem',
                background: '#2F7D5B',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              + Nouveau chauffeur
            </button>
          )}
        </div>

        {drivers.length === 0 ? (
          <p>Aucun chauffeur enregistré.</p>
        ) : (
          <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Email</th>
                <th>Téléphone</th>
                <th>Date d'embauche</th>
                <th>Matricule</th>
                <th>Agence</th>
                <th>Véhicule</th>
                <th>Statut</th>
                {(user.role === 'admin' || user.role === 'manager') && <th>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {drivers.map((driver) => (
                <tr key={driver.id}>
                  <td>
                    <strong>{driver.firstname} {driver.lastname}</strong>
                  </td>
                  <td>{driver.email}</td>
                  <td>{driver.phone || '-'}</td>
                  <td>{driver.hire_date ? format(new Date(driver.hire_date), 'dd/MM/yyyy') : '-'}</td>
                  <td>{driver.internal_id || '-'}</td>
                  <td>{driver.agency || '-'}</td>
                  <td>{driver.vehicle_plate || '-'} {driver.vehicle_type && `(${driver.vehicle_type})`}</td>
                  <td>
                    <span className={`status-badge ${driver.status === 'active' ? 'status-active' : 'status-inactive'}`}>
                      {driver.status === 'active' ? 'Actif' : 'Inactif'}
                    </span>
                  </td>
                  {(user.role === 'admin' || user.role === 'manager') && (
                    <td>
                      <button
                        onClick={() => navigate(`/drivers/edit/${driver.id}`)}
                        style={{
                          padding: '0.5rem 1rem',
                          background: '#B8472E',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          cursor: 'pointer'
                        }}
                      >
                        Modifier
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Drivers;
